import { render } from "./Result.vue?vue&type=template&id=7dd67762&scoped=true&ts=true"
import script from "./Result.vue?vue&type=script&lang=ts"
export * from "./Result.vue?vue&type=script&lang=ts"

import "./Result.vue?vue&type=style&index=0&id=7dd67762&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dd67762"]])

export default __exports__